import React from 'react';
import PropTypes from 'prop-types';

const DAY_FULL = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const DAY_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const formatSchedule = (daysOfWeek) => {
  const days = [...(daysOfWeek || [])].sort((a, b) => a - b);
  if (days.length === 0) return '—';
  if (days.length === 7) return 'Every day';
  if (days.length === 1) return `Every ${DAY_FULL[days[0]]}`;
  return `Every ${days.map((n) => DAY_SHORT[n]).join('/')}`;
};

const ScheduleCell = ({ daysOfWeek }) => (
  <span className="series-schedule-cell">
    {formatSchedule(daysOfWeek)}
  </span>
);

ScheduleCell.propTypes = {
  daysOfWeek: PropTypes.arrayOf(PropTypes.number),
};

export default ScheduleCell;
